import { Component } from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';

import styles from './OnClickAnalyticEvent.scss';

class OnClickAnalyticEvent extends Component {
  static propTypes = {
    children: PropTypes.node,
    eventAction: PropTypes.string,
    eventCategory: PropTypes.string,
    eventOptions: PropTypes.object,
  };

  static contextTypes = {
    analyticsService: PropTypes.object.isRequired,
  };

  onClick = () => {
    const { eventAction, eventCategory, eventOptions } = this.props;

    this.context.analyticsService.track(eventAction, eventCategory, eventOptions);
  };

  render() {
    const { children } = this.props;

    return (
      <span
        onClick={this.onClick}
        onKeyPress={this.onClick}
        role="button"
        styleName="m-analytics-click"
        tabIndex={0}
      >
        {children}
      </span>
    );
  }
}

export default CSSModules(OnClickAnalyticEvent, styles);
